import {
  REFUND_BATCH_GETTING,
  REFUND_BATCH_GET_SUCCESS,
  REFUND_BATCH_GET_FAILED,
  REFUND_BATCH_UPDATING,
  REFUND_BATCH_UPDATE_SUCCESS,
  REFUND_BATCH_UPDATED_FAILED
} from './actions';

const initialState = {
  refund: { "configData": [], "error":"", loading: true }
}

export function refundBatchConfigReducer(state = initialState, action) {
  let data = action.payload;

  switch (action.type) {
    case REFUND_BATCH_GETTING:
      return {
        ...state,
        loading: true,
        configData: null,
        error: null
      }

    case REFUND_BATCH_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        configData: data,
        error: null
      }

    case REFUND_BATCH_GET_FAILED:
      return {
        ...state,
        loading: false,
        configData: null,
        error: "Get refund config failed: " + data.statusText
      }

    case REFUND_BATCH_UPDATING:
      return {
        ...state,
        loading: true,
        configData: null,
        error: null
      }

    case REFUND_BATCH_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        configData: data,
        error: null
      }

    case REFUND_BATCH_UPDATED_FAILED:
      return {
        ...state,
        loading: false,
        configData: null,
        error: "Update refund config failed: " + data.statusText
      }


    default:
      return state;
  }
}
